// import { useState, useEffect } from 'react'
// import { Timer } from './Date'  // interest BUG - if run - canvas UPDATE Height
import Scene from './Scene';
import GUI from './GUI';
import AddText from './AddText';
/**
 *  TODO also test MatCap materials
 */
const materials = [
  './3d-model/materials/FabricRough_Base_Color.png',
  './3d-model/materials/LeatherBlack_Base_Color.png',
  './3d-model/materials/LeatherBrown_Base_Color.png',
];
// const matCaps = [
//   './Textures/matcaps/gel_1.png',
//   './Textures/matcaps/metal_1.png',
//   './Textures/matcaps/metal_2.png',
//   './Textures/matcaps/metal_3.png',
//   './Textures/matcaps/metal_4.png',
//   './Textures/matcaps/metal_5.png',
//   './Textures/matcaps/metal_6.jpg',
//   './Textures/matcaps/metal_7.jpg',
//   './Textures/matcaps/pngegg (1).png',
//   './Textures/matcaps/pngegg (2).png',
//   './Textures/matcaps/pngegg (3).png',
//   './Textures/matcaps/pngegg (4).png',
//   './Textures/matcaps/pngegg (5).png',
//   './Textures/matcaps/pngegg (6).png',
//   './Textures/matcaps/pngegg (7).png',
//   './Textures/matcaps/pngegg.png',
//   './Textures/matcaps/reflect_1.png',
// ];

export default function App() {
  return (
    <>
      <Scene />
      {/* <Timer /> */}
      {/* <GUI /> */}
      <AddText />
    </>
  );
}
